export default __webpack_public_path__ + "static/media/mastercard.3054b4cf.svg";